"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.changeWindowTitle = void 0;
const bridge_1 = require("../bridge");
const errors_1 = require("../errors");
const callBridge = (0, bridge_1.getCallBridge)();
const changeWindowTitle = async (title) => {
    try {
        await callBridge('changeWindowTitle', title);
    }
    catch (e) {
        throw new errors_1.BridgeAPIError("the window title wasn't changed due to error.");
    }
};
exports.changeWindowTitle = changeWindowTitle;
